import { createContext, JSXElementConstructor, ReactElement, ReactFragment, ReactPortal, useContext, useState } from 'react';
import axios from 'axios'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, User, signInWithCustomToken, onAuthStateChanged, signOut } from "firebase/auth";


const AuthContext = createContext<Auth | null>(null);

interface Auth {
    user: User | null,
    login: (email: string, password: string) => Promise<void>,
    authentication: () => Promise<void>,
    logout: () => Promise<void>,
}



export function useAuth() {
    const auth = useContext(AuthContext);
    if (!auth) throw new Error('You forgot AuthProvider!');
    return auth;
}

export function AuthProvider(props: { children: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; }) {

    const [state, setState] = useState<Auth>({
        user: null,
        login,
        authentication,
        logout,
    });

    async function login(email: string, password: string) {

        try {
            const auth = getAuth();

            let userCredential = await signInWithEmailAndPassword(auth, email, password)

            setState(prevState => ({ ...prevState, user: userCredential.user }));


        } catch (error: any) {
            const errorCode = error.code;
            const errorMessage = error.message;
            alert(errorMessage)

        }

    }

    async function authentication() {
        try {
            const auth = getAuth();
            onAuthStateChanged(auth, (user) => {
                if (user) {

                    setState(prevState => ({ ...prevState, user }));

                }
            });


        } catch (error: any) {
            const errorCode = error.code;
            const errorMessage = error.message;

            console.log(errorMessage);
        }


    }

    async function logout() {
        const auth = getAuth();

        await signOut(auth)
        setState(prevState => ({ ...prevState, user: null }));
    }

    return (
        <AuthContext.Provider value={state}>
            {props.children}
        </AuthContext.Provider>
    );
}